import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.find-index.js";
import React, { useCallback, useState } from 'react';
import hash from '../../../hash';
import { sortItemsByNodePath } from '../../shared/sort-items-by-node-path';

var compareCitations = function compareCitations(a, b) {
  return a.targetHash === b.targetHash;
};

var hasCitation = function hasCitation(citations, citation) {
  return citations.find(function (cit) {
    return compareCitations(cit.citation, citation);
  });
};

export var buildCitationHash = function buildCitationHash(publication, title, accessDate, showInline) {
  return hash({
    publication: publication,
    title: title,
    accessDate: accessDate,
    showInline: showInline
  });
};
var CitationContext = /*#__PURE__*/React.createContext(null);

var CitationContextProvider = function CitationContextProvider(_ref) {
  var children = _ref.children;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      inlineCitations = _useState2[0],
      setInlineCitations = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      extraCitations = _useState4[0],
      setExtraCitations = _useState4[1];

  var registerCitation = useCallback(function (citation, nodePath) {
    var setCitations = citation.showInline ? setInlineCitations : setExtraCitations;
    setCitations(function (citationList) {
      // Don't register the same citation twice
      return hasCitation(citationList, citation) ? citationList : sortItemsByNodePath([].concat(_toConsumableArray(citationList), [{
        citation: citation,
        nodePath: nodePath
      }]));
    });
  }, []);
  var unregisterCitation = useCallback(function (citation) {
    var setCitations = citation.showInline ? setInlineCitations : setExtraCitations;
    setCitations(function (c) {
      var newCitations = c.filter(function (cit) {
        return !compareCitations(cit.citation, citation);
      });

      if (c.length === newCitations.length) {
        return c;
      }

      return newCitations;
    });
  }, []);
  var selectCitation = useCallback(function (citation) {
    var citationArray = _toConsumableArray(inlineCitations);

    citationArray.forEach(function (c) {
      // eslint-disable-next-line no-param-reassign
      c.citation.selected = false;
    });
    var selectedCitation = citationArray.find(function (c) {
      return compareCitations(c.citation, citation) === true;
    });

    if (!selectedCitation) {
      return;
    }

    selectedCitation.citation.selected = true;
    setInlineCitations(citationArray);
  }, [inlineCitations]);
  var isPrimaryReferenceForCitation = useCallback(function (citation) {
    var citationList = citation.showInline ? inlineCitations.map(function (i) {
      return i.citation;
    }) : extraCitations.map(function (i) {
      return i.citation;
    });
    return citationList.indexOf(citation) >= 0;
  }, [inlineCitations, extraCitations]);
  var getCitationNumber = useCallback(function (citation) {
    var citationList = citation.showInline ? inlineCitations.map(function (i) {
      return i.citation;
    }) : extraCitations.map(function (i) {
      return i.citation;
    });
    return citationList.findIndex(function (c) {
      return c.title === citation.title && c.publication === citation.publication;
    });
  }, [inlineCitations, extraCitations]);
  var getInlineCitations = useCallback(function () {
    return inlineCitations.map(function (i) {
      return i.citation;
    });
  }, [inlineCitations]);
  var getExtraCitations = useCallback(function () {
    return extraCitations.map(function (i) {
      return i.citation;
    });
  }, [extraCitations]);
  return /*#__PURE__*/React.createElement(CitationContext.Consumer, null, function (context) {
    return /*#__PURE__*/React.createElement(CitationContext.Provider, {
      value: context !== null && context !== void 0 ? context : {
        registerCitation: registerCitation,
        unregisterCitation: unregisterCitation,
        selectCitation: selectCitation,
        getInlineCitations: getInlineCitations,
        getExtraCitations: getExtraCitations,
        isPrimaryReferenceForCitation: isPrimaryReferenceForCitation,
        getCitationNumber: getCitationNumber
      }
    }, children);
  });
};

export default CitationContext;
export { CitationContextProvider };